export default function <T>(items: (T | null | undefined)[]): NonNullable<T>[] {
  return items.filter((item) => item != null) as NonNullable<T>[];
}
